export enum CampaignPlaceholderId {
    HeaderBanner = 'header-banner',
}
